import { render } from "./SlidingMenu.vue?vue&type=template&id=8fbd3cb2&scoped=true"
import script from "./SlidingMenu.vue?vue&type=script&lang=js"
export * from "./SlidingMenu.vue?vue&type=script&lang=js"

import "./SlidingMenu.vue?vue&type=style&index=0&id=8fbd3cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fbd3cb2"

export default script